import React from "react";

import { Box, Container, Grid, Typography, useTheme } from "@mui/material";
import { globalVariables } from "../../global/GlobalVariables";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import SocialsGroup from "../../components/layout/SocialsGroup";

export default function Maintenance() {
  const globalVars = globalVariables();
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        minHeight: "100vh",
        backgroundColor: "banner.main",
        color: "banner.contrastText",
      }}
    >
      <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
        <Grid
          container
          sx={{
            gap: 2,
            p: 2,
          }}
          spacing={2}
        >
          <Grid item xs={12} textAlign="center">
            <Typography variant="h3" gutterBottom>
              This site is currently undergoing brief scheduled maintenance.
            </Typography>
            <Typography variant="h4" sx={{ pb: 2 }}>
              Please check back shortly.
            </Typography>
          </Grid>
          <Grid item xs={12} textAlign="center">
            <img
              src={`${getEnvironmentVariable(
                "SYSTEM_IMAGES_CLOUDFRONT"
              )}/images/BannerLogo${
                theme?.palette?.mode === "dark" ? "Dark" : ""
              }.png`}
              alt={globalVars?.site?.title || "Best Coast Pairings"}
              style={{
                height: "150px",
                maxWidth: "80%",
              }}
            />
          </Grid>
          <Grid item xs={12} textAlign="center">
            <SocialsGroup />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
